import { BodyText, Button, CloseIcon, Col, Container, IconButton, Row } from '@farol-ds/react'
import { getCookie, setJusbrasilCookie } from '@jusbrasil-web/shared-utils-cookies'
import { useEffect, useState } from 'react'

import styles from './view-lock-toast.module.scss'

const COOKIE_NAME = 'view-lock-toast-viewed'

export const ViewLockToast = () => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const shouldOpen = !getCookie(null, COOKIE_NAME)
    setIsOpen(shouldOpen)

    if (shouldOpen) setJusbrasilCookie(null, COOKIE_NAME, true)
  }, [])

  const onClickCallback = () => {
    setIsOpen(false)
    const win = window.open(
      'https://www.jusbrasil.com.br/pro?fromComponent=ViewLockToast',
      '_blank'
    )
    win?.focus()
  }

  if (!isOpen) return null

  return (
    <div data-testid="view-lock-toast" className={styles.root}>
      <Container>
        <Row>
          <Col xs={12} sm={8} className={styles.message}>
            <div className={styles.messageText}>
              <BodyText size="md" className={styles.title} asChild>
                <p>O acervo de informação jurídica mais completo do país ao seu alcance.</p>
              </BodyText>

              <BodyText size="md">
                Tenha acesso ilimitado a jurisprudência, modelos e peças com os planos de Pesquisa
                Jurídica.
              </BodyText>
            </div>

            <IconButton
              label="Fechar"
              icon={<CloseIcon />}
              className={styles.messageClose}
              onClick={() => setIsOpen(false)}
            />
          </Col>

          <Col xs={12} sm={4} className={styles.action}>
            <Button kind="secondary" onClick={onClickCallback} className={styles.actionCTA}>
              Conhecer planos
            </Button>

            <IconButton
              label="Fechar"
              icon={<CloseIcon />}
              className={styles.actionClose}
              onClick={() => setIsOpen(false)}
            />
          </Col>
        </Row>
      </Container>
    </div>
  )
}
